import { Typography } from '@mui/material';
import {
  FinanceProgram,
  FinanceProgramInsuranceCoverage,
  InsuranceQuote,
} from '@trnsact/trnsact-shared-types';

export const InsuranceCoverageRequirements = ({
  financeProgram,
  insuranceQuote,
  commonClasses
}: {
  financeProgram?: FinanceProgram,
  insuranceQuote?: InsuranceQuote,
  commonClasses: any,
}) => {

  if (!financeProgram?.insuranceCoverage && !insuranceQuote?.insuranceCoverage) {
    return null;
  }

  const insuranceCoverage = financeProgram?.insuranceCoverage || insuranceQuote?.insuranceCoverage;

  if (!insuranceCoverage) {
    return null;
  }

  const insuranceCoverageKeys = Object.keys(insuranceCoverage ?? {}).filter(k => k !== '__typename') as (keyof FinanceProgramInsuranceCoverage)[];

  return <>
    <Typography variant='h5' className={commonClasses.subHeader}>Insurance Coverage Requirements</Typography>
    {insuranceCoverageKeys.map(key => <div key={key} dangerouslySetInnerHTML={{ __html: insuranceCoverage[key]! }}></div>)}
  </>
};
